import TriangleContent from "../TriangleContent/TriangleContent";
import { TriangleHeaderTh } from "./TriangleHeader.styled";

interface Props {
  leftText: string;
  rightText: string;
  colSpan?: number;
  rowSpan?: number;
  width?: string;
  style?: any;
}

const TriangleHeader = ({
  leftText,
  rightText,
  colSpan = 1,
  rowSpan = 1,
  width,
  ...props
}: Props) => {
  const leftTextLength = leftText?.length || 0;
  const rightTextLength = rightText?.length || 0;

  const minWidth = Math.max(
    120,
    colSpan * 90,
    Math.max(leftTextLength, rightTextLength) * 7,
  );

  const baseMinHeight = Math.max(
    50,
    (Math.ceil(leftTextLength / 10) + Math.ceil(rightTextLength / 10)) * 20,
  );

  const style = {
    minWidth: `${minWidth}px`,
    minHeight: `${baseMinHeight}px`,
    width: width || undefined,
    height: rowSpan > 1 ? "100%" : undefined,
    ...props.style,
  };

  return (
    <TriangleHeaderTh
      colSpan={colSpan}
      rowSpan={rowSpan}
      style={style}
      className="triangle"
      data-left={leftText}
      data-right={rightText}
      {...props}>
      <TriangleContent rowSpan={rowSpan} data={[leftText, rightText]} />
    </TriangleHeaderTh>
  );
};

export default TriangleHeader;
